import React from 'react'
import { DatePicker, Typography, Form, Col, Select } from 'antd'
import constants from '../assets/constants'
import moment from 'moment'
import _ from 'lodash'
moment.locale('it')

const Tempistiche = (props) => {
  return (
    <>
      <Typography.Title>Da quando è libero l&apos;appartamento?</Typography.Title>
      <Col xs={24} lg={6}>
        <Form.Item
          name='libero'
          rules={[
            {
              required: true
            }
          ]}
          valuePropName='libero'
        >
          <DatePicker
            defaultValue={
              props.formValue.libero
                ? moment(props.formValue.libero)
                : undefined
            }
            placeholder='Seleziona una data'
            style={{
              width: '100%'
            }}
            format='dddd D MMMM YYYY'
            showTime={false}
            showToday={false}
          />
        </Form.Item>
      </Col>
      <Typography.Title>
        Richiedi un tempo di permanenza minimo?
      </Typography.Title>
      <Col xs={24} lg={6}>
        <Form.Item
          name='permanenza'
          rules={[
            {
              required: true
            }
          ]}
        >
          <Select
            placeholder='Seleziona una categoria'
            defaultValue={constants.permanenze[0].value}
          >
            {_.map(constants.permanenze, (item, index) => (
              <Select.Option key={`permanenze_${index}`} value={item.value}>
                <Typography.Text>{item.label}</Typography.Text>
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  )
}

export default Tempistiche
